var map = {
  "./en-US.ftl": [
    "537",
    []
  ],
  "./es.ftl": [
    "59137",
    [
      7898
    ]
  ],
  "./de.ftl": [
    "89516",
    [
      6333
    ]
  ],
  "./pt-BR.ftl": [
    "27146",
    [
      8839
    ]
  ],
  "./ja.ftl": [
    "68942",
    [
      7027
    ]
  ],
  "./zh-TW.ftl": [
    "81023",
    [
      8964
    ]
  ],
  "./fr.ftl": [
    "23293",
    [
      1550
    ]
  ],
  "./ru.ftl": [
    "40730",
    [
      3255
    ]
  ],
  "./zh-CN.ftl": [
    "39555",
    [
      9456
    ]
  ],
  "./ko.ftl": [
    "45687",
    [
      8604
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids[1].map(function(chunkId) { return __webpack_require__.e(chunkId); })).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 91369;
module.exports = __rspack_async_context;
